import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row cart-empty text-center cart-checkout__empty" };
const _hoisted_2 = { class: "mt-5" };
const _hoisted_3 = { class: "text-muted mt-5" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_g_icon, {
                width: "120",
                height: "120",
                src: "/assets/icons/cart.svg",
                class: "text-muted"
            })
        ]),
        _createElementVNode("h2", _hoisted_3, [
            (_ctx.schema?.options?.emptyText)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.schema?.options?.emptyText), 1)
                ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.$tc('client.Commerce.Carts.Empty')), 1)
                ], 64))
        ])
    ]));
}
